module.exports = __webpack_public_path__ + "img/perform_2.9d339e03.svg";